<template>
  <div v-if="isVisible" class="modal-overlay">
    <DDialog :modelValue="isVisible" @update:modelValue="updateVisibility">
      <DCard>
        <DCardSection>
          <DFile label="Choose image" filled v-model="file" accept="image/png" @update:model-value="onFileChange" />
          <DImg :src="imagePreview" fit="contain" style="max-width: 400px; max-height: 20vh; margin-top: 10px;"
            v-if="imagePreview" :style="imagePreviewStyle" />
          <DInput type="number" v-model="size" label="Size of image[%]" placeholder="Size" />
          <DInput type="number" v-model="speed" label="Speed" placeholder="Speed" @update:model-value="onSpeedChange" />
          <DInput type="number" v-model="xposition" label="X position" placeholder="X position" />
          <DInput type="number" v-model="yposition" label="Y position" placeholder="Y position" />
          <DInput type="text" v-model="path" label="Path" />
        </DCardSection>

        <DCardSection align="right">
          <DButton color="primary" label="Cancel" @click="onCancelClick" />
          <DButton color="positive" :label="initialData ? 'Save' : 'Add'" @click="onOKClick" />
        </DCardSection>
      </DCard>
    </DDialog>
  </div>
</template>

<script>
import DButton from '@components/ui/DButton.vue'
import DCard from '@components/ui/DCard.vue'
import DCardSection from '@components/ui/DCardSection.vue'
import DDialog from '@components/ui/DDialog.vue'
import DInput from '@components/ui/DInput.vue'
import DFile from '@components/ui/DFile.vue'
import DImg from '@components/ui/DImg.vue'
export default {
  components: {
    DButton,
    DCard,
    DCardSection,
    DDialog,
    DInput,
    DImg,
    DFile
  },
  data() {
    return {
      file: null,
      imagePreview: null,
      xposition: 0,
      yposition: 50,
      speed: 50,
      size: 50,
      path: '',
      name: '',
      imagePreviewStyle: {},
    }
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    if (this.initialData == null) return
    this.imagePreview = this.initialData.image?.data || this.imagePreview
    this.xposition = this.initialData.xPosition || this.xposition
    this.yposition = this.initialData.yPosition || this.yposition
    this.speed = this.initialData.speed || this.speed
    this.size = this.initialData.size || this.size
    this.path = this.initialData.path || this.path
    this.name = this.initialData.image?.name || this.name
    this.imagePreviewStyle = {
      transform: this.speed < 0 ? 'scaleX(-1)' : 'scaleX(1)'
    }
  },
  watch: {
    isVisible(newVal) {
      if (!newVal) {
        this.restart()
      } else if(this.initialData) {
        this.fillInitialData()
      }
    },
  },
  methods: {
    fillInitialData() {
      this.imagePreview = this.initialData.image?.data || this.imagePreview
      this.xposition = this.initialData.xPosition || this.xposition
      this.yposition = this.initialData.yPosition || this.yposition
      this.speed = this.initialData.speed || this.speed
      this.size = this.initialData.size || this.size
      this.path = this.initialData.path || this.path
      this.name = this.initialData.image?.name || this.name
      this.imagePreviewStyle = {
        transform: this.speed < 0 ? 'scaleX(-1)' : 'scaleX(1)'
      }
    },
    restart() {
      this.file = null
      this.imagePreview = null
      this.xposition = 0
      this.yposition = 50
      this.speed = 50
      this.size = 50
      this.path = ''
      this.name = ''
      this.imagePreviewStyle = {}
    },
    onSpeedChange(newSpeed) {
      this.imagePreviewStyle = {
        transform: newSpeed < 0 ? 'scaleX(-1)' : 'scaleX(1)'
      }
    },
    onFileChange(fileValue) {
      const file = Array.isArray(fileValue) ? fileValue[0] : fileValue

      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
          this.name = file.name.substring(file.name.indexOf('\\', file.name.indexOf('\\') + 1) + 1, file.name.lastIndexOf('.'))
        }
        reader.readAsDataURL(file)
      } else {
        this.imagePreview = null
      }
    },

    hide() {
      this.$emit('cancel')
    },

    updateVisibility(value) {
      this.$emit('update:isVisible', value)
    },

    onOKClick() {
      if (!this.file && !this.initialData) {
        this.$emit('show-notification', 'negative', 'Please select a image')
      } else {
        this.$emit('confirm', { imagePreview: this.imagePreview, speed: this.speed, name: this.name, xposition: this.xposition, yposition: this.yposition, size: this.size, path: this.path })
        this.hide()
      }
    },

    onCancelClick() {
      // we just need to hide the dialog
      this.hide()
    }
  }
}
</script>

<style  scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>